    import axiosInstance from "service/axiosInstance";
import {
  CreateTaskPayload,
  CrmTask,
  GetTasksParams,
  TaskListResponse,
  TaskResponse,
} from "types/crm/task";
import { CrmPage } from "types/crm/pagination";
import { toCrmPage } from "./pagination";
import { CrmTaskListItem } from "types/crm/task";

export const taskQueryKeys = {
  all: ["tasks"] as const,
  list: (params: GetTasksParams) =>
    [...taskQueryKeys.all, "list", params] as const,
};

export const taskApi = {
  getAllTasks: async ({
    search,
    status,
    page = 0,
    size = 20,
  }: GetTasksParams): Promise<CrmPage<CrmTaskListItem>> => {
    const { data } = await axiosInstance.get<TaskListResponse>("/crm/tasks", {
      params: {
        search: search?.trim() || undefined,
        status: status || undefined,
        page,
        size,
      },
    });
    return toCrmPage<CrmTaskListItem>(data.data, page, size);
  },

  createTask: async (payload: CreateTaskPayload): Promise<CrmTask> => {
    const { data } = await axiosInstance.post<TaskResponse>(
      "/crm/tasks",
      payload,
    );
    return data.data;
  },
};